<div class="align-items-center">
  <div class="row g-3">
    @for (card of multiProductCards(); track card) {
      <div class="col-12 col-lg-6" (click)="cardClicked.emit(card)">
        @if (!useSelectableCards()) {
          <mwe-multi-product-card
            [ngClass]="{ 'd-block pointer': hasMousePointerStyle() }"
            [card]="card"
            [isDisabled]="isDisabled()"
            [showCompanyReference]="showCompanyReference()"
            [showSummarizedCompanyReference]="showSummarizedCompanyReference()"
            [showAccountNumber]="showAccountNumber()"
            [showCustomerNumber]="showCustomerNumber()"
          >
            @if (showSlider() && !isDisabled) {
              <div class="card-basic-body py-3 border-top">
                <mwe-product-card-slider
                  [id]="card.id"
                  [initialValue]="card.isChecked"
                  [showCompanyReference]="showCompanyReference()"
                  toggleOnMsgKey="invoiceData.change.newAccount.toggleLabel.toggleOn"
                  toggleOffMsgKey="invoiceData.change.newAccount.toggleLabel.toggleOff"
                  (sliderState)="handleSliderResponse($event)"
                />
              </div>
            }
          </mwe-multi-product-card>
        } @else {
          <mwe-card-selectable
            [isSelected]="card.isChecked"
            data-test="mwe-multi-product-card"
            [disabled]="isDisabled() || isOnlyOneVk()"
            (changed)="handleSliderResponse({ id: card.id, checked: $event })"
            [readonly]="isOnlyOneVk()"
            [isInvalid]="isInvalid() || null"
          >
            <div class="mb-1">
              <mwe-product-icons [categories]="card.categories" [textNodeType]="headlineNodeType()" size="xl" />
            </div>
            @if (showCustomerNumber()) {
              <p class="mb-1">
                <b>{{ 'products.details.customerNumber' | translate }}</b
                >&nbsp;<span>{{ card.customerNumbers[0] }}</span>
              </p>
            }
            @if (showSummarizedCompanyReference() && !showCompanyReference() && card?.categories?.length > 0) {
              <div class="text--legal mt-1">
                {{ card.categories[0] | correlatedCompanyReference }}
              </div>
            }
          </mwe-card-selectable>
        }
      </div>
    }
  </div>
</div>
